<div
    class="inner-content dark:rounded-2xl dark:border-2 dark:border-solid dark:border-contrast-yellow"
    ridangoAppTrapFocus>
    <div class="flex-column flex h-full text-base">
        <div class="align-center my-6">
            <h2 class="font-semibold">
                {{ 'DISCARD_PURCHASE' | translate }}
            </h2>
        </div>
        <div class="w-full">
            <div class="text-center">
                <p>{{ 'DISCARD_PURCHASE_DESCRIPTION' | translate }}&nbsp;</p>
            </div>
            <div class="flex-column">
                <button
                    class="orb-app-light:text-secondary btn--link btn--maximal btn--big link--no-line link--no-hover mt-4 rounded-lg text-primary dark:text-contrast-yellow"
                    [attr.aria-label]="'CANCEL_PURCHASE_LEAVE' | translate"
                    (click)="cancelLeavePurchase()"
                    type="button">
                    {{ 'CANCEL_PURCHASE_LEAVE' | translate }}
                </button>
                <button
                    class="orb-app-light:text-black btn--primary var-app-light:text-primary h-14 w-full rounded-lg font-bold dark:bg-contrast-yellow dark:text-contrast-black"
                    [attr.aria-label]="'EXIT_BTN' | translate"
                    (click)="leavePurchase()"
                    type="button">
                    {{ 'EXIT_BTN' | translate }}
                </button>
            </div>
        </div>
    </div>
</div>
